import React from "react";
import { Views, DetailsViews } from "./api/views";

const Context = React.createContext<{
  cell: { height: number; width: number };
  currentView: Views;
  detailsView: DetailsViews;
  areDetailsOpen: boolean;
  selectDetailsView(detailsView: DetailsViews): void;
  selectView(currentView: Views): void;

  areWorkloadsToggled: boolean;
  toggleWorkloads(): void;

  areDelaysToggled: boolean;
  toggleDelays(): void;

  areDerivationsToggled: boolean;
  toggleDerivations(): void;

  areWorkloadsGroupsToggled: boolean;
  toggleWorkloadsGroups(): void;

  setProjectElementsNbr(id: string, nbr: number): void;
}>({
  setProjectElementsNbr() {},
  cell: { height: 25, width: 25 },
  currentView: Views.DAILY,
  detailsView: DetailsViews.DATES,
  areDetailsOpen: false,
  selectDetailsView() {},
  selectView() {},

  areWorkloadsToggled: false,
  toggleWorkloads() {},

  areDelaysToggled: false,
  toggleDelays() {},

  areDerivationsToggled: false,
  toggleDerivations() {},

  areWorkloadsGroupsToggled: false,
  toggleWorkloadsGroups() {},
});

export { Context };
